import { Trans, useTranslation } from "react-i18next";
import { useCloudAuth } from "../../hooks/useCloudAuth";

export function PendingApproval() {
  const { t } = useTranslation();
  const { user, logout } = useCloudAuth();

  const registeredDate = user?.createdAt
    ? new Date(user.createdAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "recently";

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <div className="mb-6">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-orange-500/10 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-orange-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-[#f5f5f5] mb-2">{t('auth.pending.title')}</h1>
        <p className="text-[#999]">{t('auth.pending.subtitle')}</p>
      </div>

      <div className="bg-[#1a1a1a] border border-[#333] rounded-lg p-6 text-left">
        <p className="text-[#999] text-sm mb-4">
          <Trans
            i18nKey="auth.pending.registeredInfo"
            values={{ date: registeredDate, email: user?.email }}
            components={{
              date: <span className="text-[#f5f5f5]" />,
              email: <span className="text-[#f5f5f5]" />,
            }}
          />
        </p>

        <p className="text-[#999] text-sm">
          {t('auth.pending.notificationNote')}
        </p>
      </div>

      <div className="mt-6">
        <button
          onClick={logout}
          className="text-[#999] text-sm hover:text-[#f5f5f5] transition-colors underline underline-offset-2"
        >
          {t('auth.signOut')}
        </button>
      </div>
    </div>
  );
}
